var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AlfatronDspBase } from './util/AlfatronDspBase';
export class AlfatronDspTcp extends AlfatronDspBase {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        super(AlfatronDspTcp.driverType, state, log, framework);
        this.socket = socket;
    }
    send(command, match, tags, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.socket.send(command, match, tags, options);
        });
    }
}
// static properties
AlfatronDspTcp.driverType = 'socketDriver';
AlfatronDspTcp.key = '-N5CrC5i7GUhmSnsU52s';
AlfatronDspTcp.channelsConfigName = 'alfatronDsp88ControlChannels';
AlfatronDspTcp.socketOptions = [
    {
        commandExtractor: (buffer) => {
            // commands are 12 bytes in length and start with 0xb3
            for (let i = 0; i < buffer.length - 1; i++) {
                if (buffer.length - i >= 12 &&
                    buffer.charCodeAt(i) === 0xb3 &&
                    [0x13, 0x21, 0x22].includes(buffer.charCodeAt(i + 1))) {
                    const command = buffer.slice(i, i + 12);
                    buffer = buffer.slice(i + 12);
                    return { command, buffer };
                }
            }
            return undefined;
        },
        isBinary: true,
        port: 4999,
        sendTerminator: '',
    },
];
